module.exports = __webpack_public_path__ + "static/img/2.34901e34.jpg";